import CreditCardPay from './credit-card-pay';

export default CreditCardPay;
